var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#801950;}.e{fill:none;stroke:#801950;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "418.28 426.26 93.72 426.26 93.72 85.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 128.3,
    y: 220.48,
    width: 81.14,
    height: 177.85,
    rx: 18.36,
    ry: 18.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 231.97,
    y: 158.57,
    width: 81.14,
    height: 239.6,
    rx: 18.36,
    ry: 18.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 336.76,
    y: 94.79,
    width: 81.14,
    height: 303.61,
    rx: 18.36,
    ry: 18.36
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityOn);
export default __webpack_public_path__ + "static/media/activity_on.e4d003a5e81f60ae0996b3b08a40bb56.svg";
export { ForwardRef as ReactComponent };